export interface KingdomContactConfig {
  activeWhatsappNumber: string; // e.g. "+2348059079068"
  secretariatEmail: string;     // e.g. "erueuzairue@gmail.com"
  supportPhone: string;         // e.g. "+234 805 907 9068"
  secretariatAddress: string;  // e.g. "Ogieneni Palace, Jattu-Uzairue, Edo State, Nigeria"
  lastUpdatedBy: string;
  lastUpdatedAt: string;
}

const CONTACT_CONFIG_KEY = 'uzairue_kingdom_contact_config_v1';
export const CONTACT_CONFIG_CHANGE_EVENT = 'uzairue_contact_config_updated';

export const DEFAULT_CONTACT_CONFIG: KingdomContactConfig = {
  activeWhatsappNumber: '+2348059079068',
  secretariatEmail: 'erueuzairue@gmail.com',
  supportPhone: '+234 805 907 9068',
  secretariatAddress: 'Ogieneni Palace, Jattu-Uzairue, Edo State, Nigeria',
  lastUpdatedBy: 'Ikpemhi Oshioke (erueuzairue@gmail.com)',
  lastUpdatedAt: new Date().toISOString(),
};

export function getContactConfig(): KingdomContactConfig {
  try {
    const raw = localStorage.getItem(CONTACT_CONFIG_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        ...DEFAULT_CONTACT_CONFIG,
        ...parsed,
      };
    }
  } catch (err) {
    console.error('Failed to read contact config:', err);
  }
  return DEFAULT_CONTACT_CONFIG;
}

export function saveContactConfig(config: KingdomContactConfig): void {
  try {
    localStorage.setItem(CONTACT_CONFIG_KEY, JSON.stringify(config));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(CONTACT_CONFIG_CHANGE_EVENT, { detail: config }));
    }
  } catch (err) {
    console.error('Failed to save contact config:', err);
  }
}

export function formatWhatsappUrl(phone?: string, messageText?: string): string {
  const target = phone || getContactConfig().activeWhatsappNumber;
  const cleanDigits = target.replace(/[^0-9]/g, '');
  const encodedMsg = messageText ? encodeURIComponent(messageText) : '';
  return `https://wa.me/${cleanDigits}${encodedMsg ? `?text=${encodedMsg}` : ''}`;
}
